/* @bend-expect quartz-no-create-browser-history */

import { getParsedTrackingParams } from 'marketplace-ui-common/utils/trackingParams';
import { getMarketplaceEventProps } from 'marketplace-ui-tracking';
import { createTracker as createLegacyTracker } from 'usage-tracker';
import { createContainer } from 'usage-tracker-multi';
function getSessionUrlParams() {
  const trackingParams = getParsedTrackingParams();
  return Object.keys(trackingParams).reduce((final, key) => {
    const value = trackingParams[key];
    final.push(`${key}=${value}`);
    return final;
  }, []);
}
let trackContainer;
let tracker;
export function createStandaloneTracker({
  appContext,
  history,
  referrer
}) {
  if (!trackContainer) {
    trackContainer = createContainer({
      history
    });
  }
  if (!tracker) {
    tracker = trackContainer.createTracker({
      standalone: true,
      trackerType: appContext === 'app' ? 'authed' : 'public',
      properties: getMarketplaceEventProps({
        inAppOrPublic: appContext === 'app' ? 'in-app' : 'public',
        referrer,
        sessionUrlParams: getSessionUrlParams()
      }),
      lastKnownEventProperties: ['screen']
    });
  }
  return tracker;
}
export function createTracker({
  appContext,
  referrer
}) {
  return createLegacyTracker({
    lastKnownEventProperties: ['screen'],
    properties: {
      inAppOrPublic: appContext === 'app' ? 'in-app' : 'public',
      namespace: 'marketplace',
      referrer,
      sessionUrlParams: getSessionUrlParams()
    }
  });
}
export function getSourceIdByCard(card) {
  return card.products.map(({
    sourceId,
    productType
  }) => `${String(productType)}__${sourceId}`);
}
export function getProdutTypeByCard(card) {
  return card.products.map(({
    productType
  }) => productType);
}